import React from 'react';
import { getServicePrice } from '../../booking/utils';

function CartBanner({ selectedServices, onToggleService, onAddAnother }) {
  if (!selectedServices?.length) return null;
  const cartTotal = selectedServices.reduce((sum, s) => sum + getServicePrice(s), 0);
  return (
    <div className="cart-top-banner" key={selectedServices.length}>
      <div className="cart-top-header">
        <span className="cart-top-label">
          <span className="cart-badge">{selectedServices.length}</span>
          Your Services
        </span>
        <span className="cart-top-total">${cartTotal.toFixed(2)}</span>
      </div>
      <div className="cart-top-items">
        {selectedServices.map(svc => (
          <div key={svc.id} className="cart-top-chip">
            <span>{svc.display_name || svc.name}</span>
            <button
              className="cart-top-chip-remove"
              onClick={(e) => { e.stopPropagation(); onToggleService(svc); }}
              aria-label={`Remove ${svc.display_name || svc.name}`}
            >
              ✕
            </button>
          </div>
        ))}
        {onAddAnother && (
          <button type="button" className="cart-top-add-chip" onClick={onAddAnother}>
            + Add another service
          </button>
        )}
      </div>
    </div>
  );
}

export default CartBanner;
